import { useMemo, useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_DOCTOR, GET_SPECIALTY, GET_REVIEWS } from './header.gql';

export const useHeader = () => {
  
  const { data: speciatiesData, loading: speciatiesLoading } = useQuery(GET_SPECIALTY);

  const specialties = useMemo(() => {
    if (speciatiesData?.specialties) {
      return speciatiesData?.specialties;
    }
  }, [speciatiesData]);

  return {
    specialties,
  };

};
